import "./index.css";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";

import { store } from "./redux";
import Router from "./containers/Router";
// import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { config } from "./config";

Sentry.init({
  dsn: "https://c60941d96adfabdef005a7eec17849fb@o382392.ingest.us.sentry.io/4508878930771968",
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: config.inProd ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
